/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import {GetLocalText, GenerateProductAssetUrl} from "./../../themes/kent/utilities/functions";
// @ts-ignore
import {GeneralAssetUrl} from "./../../themes/kent/utilities/constants";
// @ts-ignore
import PortalModal from './../portal-modal/./portal-modal';
//@ts-ignore
import ReactImageMagnify from 'react-image-magnify';

let loadedImages = [];

interface IState {
  product?:any;
  zoomActive?:any;
  selectedIndex?:any;
  doneLoading?:any;
  images?:any;
}

interface IProps {
  product?: any;
  hideTitle?:boolean;
  year?:any;
}

/**
 *
 * Thumbnails component
 * @extends {React.Component<IProps,IState>}
 */

class Thumbnails extends React.Component<IProps,IState> {
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      product:this.props.product,
      zoomActive:false
    };
  }

  componentDidMount = () => {
    var images = [];
    let prodAssetUrl:string = GenerateProductAssetUrl(this.props.year);
    for (var i = 0; i < 10; i++) {
      images.push({
        large:prodAssetUrl+this.props.product.attributes.slug+i+'.png',
        medium:prodAssetUrl+this.props.product.attributes.slug+i+'_1000.png',
        thumb: prodAssetUrl+this.props.product.attributes.slug+i+'_500.png'
      });
      if(i == 9){
        this.setState({
          images:images,
          selectedIndex:0
        })
      }
    }
  }

  imageLoaded = (index:any) =>{
    loadedImages.push(index);
    this.checkLoadStatus()
  }

  removeImage = (index:any) =>{
    loadedImages.push(index);
    this.checkLoadStatus()
    var images = this.state.images;
    images.splice(index, 1);
    this.setState({
      images:images
    })
  }

  checkLoadStatus = () =>{
    if(loadedImages.length > 9){
      this.setState({
        doneLoading:true
      })
    }
  }

  thumbnailClicked = (index:any) => {
    this.setState({
      zoomActive:true,
      selectedIndex:index
    })
  }

  hideZoom =() =>{
    this.setState({
      zoomActive:false
    })
  }

  public render(): JSX.Element {
    if(!this.state.images) return <span />
    let loadedClass = '';
    if(this.state.doneLoading){
      loadedClass = 'loaded';
    }
    let descriptors:any = this.props.product.attributes.thumbDescriptions;

    return(
      <div className={"row product-thumbnail-row tiny-top-margin "+loadedClass}>
        {this.state.images.map((image:any,index:number) => {
          return(
            <div className="small-4 medium-3 large-2 product-thumbnail-list-item" style={{padding:"2px"}}>
              <img
                ref={"thumbnail"+index}
                className={"zoomable-small full-width primary-background"}
                src={image.thumb}
                onLoad={()=>this.imageLoaded(index)}
                onError={()=>this.removeImage(index)}
                onClick={()=>this.thumbnailClicked(index)}
              />
              {descriptors && descriptors[index] && <div className="full-width centered-text white-background"><h6>{descriptors[index]}</h6></div>}
            </div>
          )
        })}
        {this.state.zoomActive &&
          <PortalModal
            modalActive={this.state.zoomActive}
            modalHidden={this.hideZoom}
            theme="light"
            content={
              <div className="full-height full-width flex primary-background" style={{display:'flex', alignItems:'center',justifyContent:'center'}}>
                <ReactImageMagnify {...{
                  enlargedImageClassName:'zoomable-large',
                  imageClassName:'zoomable-medium',
                  isActivatedOnTouch:true,
                  smallImage: {
                    alt: '',
                    src: this.state.images[this.state.selectedIndex].medium,
                    width: window.innerHeight*.9,
                    height:window.innerHeight*.9
                  },
                  largeImage: {
                    src: this.state.images[this.state.selectedIndex].large,
                    width: 2000,
                    height: "auto"
                  },
                  enlargedImagePosition:'over',
                }} />
            </div>
            }
            />
          }
      </div>
    )
  }
}

export default Thumbnails;
